// @flow
import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import BrandViewer from 'containers/brand/BrandViewer';
import { type Match } from 'react-router-dom';
import BrandCommentsContainer from 'containers/brand/BrandCommentsContainer';
import BrandSequencesContainer from 'containers/brand/BrandSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Brand = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <BrandViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <BrandCommentsContainer />
      </PlainTemplate>
      <BrandSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Brand;



// WEBPACK FOOTER //
// ./src/pages/Brand.js